import nearestColor from "nearest-color";
import { createSelector } from "reselect";

import { colorMap } from "../../../constants/colorOptions";

const getColorsById = state => state.definitions.colors.byId;

const getColors = createSelector(
  // inputs
  state => state.definitions.colors.allIds,
  getColorsById,
  // result
  (allIds, colorsById) => allIds.map(cId => colorsById.get(cId))
);

const getNearestColorMap = createSelector(
  // input
  getColorsById,
  // calc result
  colorsById => {
    const colors = colorsById.reduce((map, c) => {
      if (colorMap[c.swatchColor]) {
        map[c.swatchColor] = colorMap[c.swatchColor];
      }
      return map;
    }, {});
    return nearestColor.from(colors);
  }
);

const getNearestColorMapFromAllColors = () => {
  const colors = colorMap;
  return nearestColor.from(colors);
};

const getNearestColorIdByStateAndColorName = (state, name) => {
  const colorsById = getColorsById(state);
  const nearestColorMap = getNearestColorMap(state);
  const foundColor = getNearestColor(name, colorsById, nearestColorMap);
  return foundColor ? foundColor.id : null;
};

const getNearestColorNameByColorName = (colorName, colorsById, nearestColorMap) => {
  const foundColor = getNearestColor(colorName, colorsById, nearestColorMap);
  return foundColor ? foundColor.swatchColor : colorName;
};

const getNearestColor = (colorName, colorsById, nearestColorMap) => {
  let color = null;
  if (colorName) {
    const passedColor = colorMap[colorName];
    const nearestColorName = getNearestColorNameByHexCode(passedColor, nearestColorMap);
    if (nearestColorName) {
      const foundColor = colorsById.find(c => c.swatchColor === nearestColorName);
      color = foundColor;
    }
  }
  return color;
};

const getNearestColorNameByHexCode = (hexCode, nearestColorMap) => {
  let colorName = null;
  const hexCodeRegex = /^(#{0,1})([0-9A-F]{3}|[0-9A-F]{6})$/gi;
  const isHexCodeValid = hexCode.match(hexCodeRegex);

  if (isHexCodeValid) {
    const nearestColor = nearestColorMap(hexCode);
    colorName = nearestColor ? nearestColor.name : null;
  }
  return colorName;
};

export default {
  getColors,
  getColorsById,
  getNearestColorMap,
  getNearestColorMapFromAllColors,
  getNearestColorIdByStateAndColorName,
  getNearestColorNameByColorName,
  getNearestColorNameByHexCode
};
